// TODO: Convert transcripts.html to this component
// Use: useQuery with listTranscripts from transcriptService

export default function TranscriptsListPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        <div className="bg-white shadow-lg border border-gray-200 rounded-lg p-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-gray-800">📚 All Transcripts</h1>
          <p className="text-gray-600 mb-6">
            List of all interview transcripts
          </p>
          <div className="text-sm text-gray-500">
            Transcripts functionality coming soon...
          </div>
        </div>
      </div>
    </div>
  )
}
